export default {
  getDashboard: (state) => {
    return state.dashboard;
  },
  getCharts(state) {
    return state.dashboard.charts;
  }
};
